import { ReactNode } from 'react';

import { CancellationBanner } from 'new-components/OpAppScaffold/components/CancellationBanner';

export const OpAppBanners = ({ banners }: { banners?: ReactNode }) => {
  return (
    <div className="op-app-banners">
      <CancellationBanner />
      {banners}
    </div>
  );
};
